module.exports = "/_next/static/images/f864665fe2223bba292bd9ba6d217a22-nubanker-tpm@0.5x.jpg";